"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollableTableContainer = void 0;
const styles_1 = require("@mui/material/styles");
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
exports.ScrollableTableContainer = (0, styles_1.styled)(TableContainer_1.default)({
    maxHeight: "calc(100vh - 180px)",
    overflowY: "scroll",
});
